module.exports = __webpack_public_path__ + "static/media/product-3.36495355.png";